import React from 'react';
import { useParams } from 'react-router';
import { useQuery, useMutation } from '@apollo/client';
import { message } from 'antd';
import fp from 'lodash/fp';
import {
  UPDATE_ROLE_HIERARCHY,
  GET_ROLE_HIERARCHY,
} from 'gql/projectCategories';
import RoleHierarchyForm from './RoleHierarchyForm';

const getInitialValues = fp.pipe(
  fp.get('projectCategories'),
  fp.head,
  fp.get('roleHierarchy'),
  fp.get('school'),
  fp.map(({ role, sequence, level }) => ({
    role: role.id,
    sequence,
    level,
  })),
  fp.sortBy('sequence')
);

const RoleHierarchySchoolContent = () => {
  const { id } = useParams();
  const [updateRoleHierarchy] = useMutation(UPDATE_ROLE_HIERARCHY, {
    refetchQueries: [
      { query: GET_ROLE_HIERARCHY, variables: { ids: [id], state: 'ALL' } },
    ],
    onCompleted: ({ updateRoleHierarchy }) => {
      message.success(
        `Role hierarchy of ${updateRoleHierarchy.name} successfully edited`
      );
    },
    onError: (err) => {
      console.log(err);
    },
  });
  const { data, loading } = useQuery(GET_ROLE_HIERARCHY, {
    variables: { ids: [id], state: 'ALL' },
  });
  const initialValues = getInitialValues(data);

  return (
    <RoleHierarchyForm
      loading={loading}
      onFinish={(input) => {
        updateRoleHierarchy({
          variables: {
            updateRoleHierarchyInput: {
              id,
              roleHierarchy: input.roleHierarchy,
              departmentControlType: 'SCHOOL',
            },
          },
        });
      }}
      initialValues={{ roleHierarchy: initialValues }}
    />
  );
};

export default RoleHierarchySchoolContent;
